const MESSAGE_HANDLER_NAME = 'FripMessageHandler';

export enum WebviewOperatorType {
  CloseWebView = 'closeWebViewHandler',
  OpenActionUrl = 'openActionUrlHandler',
  UpdateMessageImageFileHandler = 'updateMessageImageFileHandler',
  UploadSettlementIdentityHandler = 'uploadSettlementIdentitiyHandler',
  BackwardControlHandler = 'backwardControlHandler',
  SubmitLogoutHandler = 'submitLogoutHandler',
  SetAuthorizationHandler = 'setAuthorizationHandler',
  SetMobileModalNavigate = 'setMobileModalNavigate',
  OpenWebConsoleModal = 'openWebConsoleModal',
  CheckLoggedInHandler = 'checkLoggenInHandler',
  AnalyticsEventHandler = 'analyticsEventHandler',
  LogoutHandler = 'logoutHandler',
  WithDrawHandler = 'withDrawHandler',
  EditorResizeHandler = 'editorResizeHandler',
}

export function callWebviewHandler<TParams>(
  operatorName: WebviewOperatorType,
  params?: Object | TParams,
  callbackName?: string,
) {
  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers[MESSAGE_HANDLER_NAME]
  ) {
    window.webkit.messageHandlers[MESSAGE_HANDLER_NAME].postMessage({
      operatorName,
      callbackName,
      params: params || {},
    });
    return true;
  }

  if (window.Android && window.Android[MESSAGE_HANDLER_NAME]) {
    window.Android[MESSAGE_HANDLER_NAME](
      operatorName,
      callbackName,
      JSON.stringify(params),
    );
    return true;
  }

  return false;
}

export function isWebview() {
  return (
    navigator.userAgent.includes('Frip') &&
    Boolean(window.webkit || window.Android)
  );
}

export function isIOSWebview() {
  return navigator.userAgent.includes('Frip') && Boolean(window.webkit);
}
